import * as req from 'api/actions';
import * as c from './constant';

export const getQuantityCalculationList = (id, payload, callback) =>
  req.list(
    c.GET_QUANTITY_CALCULATION_LIST,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_quantities`,
    payload,
    callback
  );

export const quantityCalculationInfo = (id, payload, callback) =>
  req.item(
    c.QUANTITY_CALCULATION_INFO,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_quantities`,
    payload,
    callback
  );

export const createQuantityFees = (id, payload, callback) =>
  req.create(
    c.CREATE_QUANTITY_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}/calculation_quantities`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeQuantityFees = (id, newOtherFeesId, payload, callback) =>
  req.remove(
    c.REMOVE_QUANTITY_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_quantities/${id}`,
    payload,
    callback
  );

export const updateQuantityFees = (id, newOtherFeesId, payload, callback) =>
  req.update(
    c.UPDATE_QUANTITY_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${newOtherFeesId}/calculation_quantities/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const getNewOtherFeesList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_NEW_OTHER_FEES,
    '/api/v1/bpls/administrator/tax_revenue/other_fees',
    payload,
    callback
  );

export const getSingleNewOtherFees = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_NEW_OTHER_FEES,
    `/api/v1/bpls/administrator/tax_revenue/other_fees/${id}`,
    payload,
    callback
  );